import { Injectable } from '@angular/core';
import { FilterData } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BookWidgetAnalyticsCategories } from '../constants/book-widget.constants';
import { BookWidgetAem } from '../models/book-widget-aem.interfaces';
import { BookWidgetFields } from '../models/book-widget-fields.interfaces';

@Injectable({
  providedIn: 'root'
})
export class BookWidgetFilterDataService {
  collectFilterData(
    bookWidgetFields: BookWidgetFields,
    bookWidgetAem: BookWidgetAem
  ): FilterData[] {
    const filters: FilterData[] = [];

    const filterConfigs = [
      {
        field: bookWidgetFields.shopMilesField,
        label: bookWidgetAem.shopMilesField.shopWithMiles
      },
      {
        field: bookWidgetFields.flexDatesField,
        label: bookWidgetAem.flexDatesField.flexDates
      },
      {
        field: bookWidgetFields.basicFaresField,
        label: bookWidgetAem.includeBasicField.includeBasic
      },
      {
        field: bookWidgetFields.refundableFareField,
        label: bookWidgetAem.refundableFareField.refundableOnly
      },
      {
        field: bookWidgetFields.flexAirportsField,
        label: bookWidgetAem.flexAirportsField.flexAirports
      }
    ];

    filterConfigs.forEach(({ field, label }) => {
      if (!field.hide) {
        filters.push({
          category: label.toLowerCase(),
          value: field.checked ? 'yes' : 'no'
        });
      }
    });

    if (!bookWidgetFields.bestFareOptionsField.hide) {
      filters.push({
        category: BookWidgetAnalyticsCategories.BEST_FARES_FOR,
        value: bookWidgetFields.bestFareOptionsField.selectedBestFare
      });
    }

    if (
      !bookWidgetFields.meetingEventCodeField.hide &&
      bookWidgetFields.meetingEventCodeField.meetingEventCodeValue
    ) {
      filters.push({
        category: BookWidgetAnalyticsCategories.MEETING_CODE,
        value: bookWidgetFields.meetingEventCodeField.meetingEventCodeValue
      });
    }

    return filters;
  }
}
